import PropTypes from 'prop-types';
import CorgixDialog from '@veeva/corgix/dialog';
import { css } from '@emotion/react';
import { isMobile } from '../services/DeviceInformation';

const propTypes = {
    actions: PropTypes.node,
    children: PropTypes.node,
    className: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    focusTrapOptions: PropTypes.object,
    open: PropTypes.bool,
    // eslint-disable-next-line react/forbid-prop-types
    overlayProps: PropTypes.object,
    size: PropTypes.string,
    title: PropTypes.node,
};

const Dialog = ({
    className,
    children,
    title,
    actions,
    open = true,
    focusTrapOptions,
    overlayProps,
    size,
}) => {
    return (
        <CorgixDialog
            className={className}
            css={({ white }) => [
                css`
                    border-radius: 8px;

                    header {
                        padding: 9px 12px 0;
                        margin: 0 0 20px;
                        height: fit-content;
                        border: none;
                        background-color: ${white};

                        & > div {
                            background-color: ${white};
                            height: fit-content;
                            line-height: 1.333rem;
                            font-size: 1.333rem;
                        }
                    }

                    & > div {
                        padding: 0 12px;
                        margin: 0 0 40px;
                        height: fit-content;
                        min-height: fit-content;
                    }

                    footer {
                        padding: 0 12px 12px;
                        button {
                            border-radius: 8px;
                            width: 100px;
                            height: 40px;
                            font-size: 16px;
                        }
                    }
                `,
                isMobile() &&
                    css`
                        footer {
                            button {
                                width: 160px;
                            }

                            button + button {
                                margin: 0 0 0 16px;
                            }
                        }
                    `,
            ]}
            open={open}
            actions={actions}
            title={title}
            draggable={false}
            size={size}
            focusTrapOptions={focusTrapOptions}
            overlayProps={overlayProps}
        >
            {children}
        </CorgixDialog>
    );
};

Dialog.propTypes = propTypes;

export default Dialog;
